import styled from 'styled-components';
import { font } from '../styles/fonts';

export default styled.div`
  position: absolute;
  z-index: 10;
  color: white;

  ${font({
    size: 20,
    weight: 700,
    lineHeight: 26,
  })}

  padding: 1rem 2rem;
  width: 100%;
`;
